let zIndexKeeper: number = 100;
let _previous: number;

const getLayerIndex = () => {
  return (_previous = zIndexKeeper += 25);
};

export const setLayerAbove = (value?: number) => {
  if (!value) {
    value = _previous;
  }

  _previous = value + 1;
  return _previous;
};

export const setLayerBelow = (value?: number) => {
  if (!value) {
    value = _previous;
  }

  _previous = value - 1;
  return _previous;
};

export const setLayerBetween = (value1: number, value2: number) => {
  _previous = parseInt((value1 + (value1 - value2) / 2).toString());

  return _previous;
};

export const setLayerSameAs = (value?: number) => {
  if (!value) {
    return _previous;
  }

  _previous = value;
  return _previous;
};

export const globalLayerIndex = {
  dropDownMenu: getLayerIndex(),
  modal: getLayerIndex(),
  anchorModal: getLayerIndex(),
  dropDownMenuModal: getLayerIndex(),
  anchorModalContent: getLayerIndex(),
  mobileDropDownMenu: getLayerIndex(),
};
